// 三维构件实体
import { resetRlModules } from "@/mixins/LiteModuleDb.js";
import rlEntity from "./rlEntity";
import store from "@/store/index";
import { addEntityToDrawing } from "@/rlMxModules/operate/commonApi";
import { rlText } from "@/rlMxModules/index";

class rlModel extends rlEntity {
  constructor() {
    super();
    this.index2dData = null; // 二维平面点集
    this.index3dData = null; // 三维面数据集合
    this.ModelNo = null; //构件编号

    this.m_sectParamData = {}; //截面参数数据
    this.SectData = []; //截面组合数据
    // this.ID = null // 数据库ID
    // this.Guid = null //Guid
    this.LevelB = null; //底标高
    this.Height = null; //层高
    this.m_sectGroupName = ""; //截面类型分组名称
    this.Strength = ""; //构件强度
    this.StrengthOther = ""; //钢筋强度--混凝土或者砂浆强度--砌体
    this.Attribute = 1; //构件类型-:1：主要构件，2：一般构件，
    this.Color = "#ffffff";
    this.m_TextObj = null; //文字对象
    this.fontSize = store.state.platBtns.fontSize; //字体大小
    this.ModelType = ""; //构件类型，用于判断是否是构件数据

    //this.rlLayer = store.state.cadModules.rlLayer
    //store.subscribe(this.handleLayerChange)
  }

  initData(obj) {
    super.initData(obj);
    this.No_ = obj.No_;
    this.m_sectParamData = obj.m_sectParamData;
    if (
      this.classTypeName !== "rlWallHole" &&
      this.classTypeName !== "SlabHole"
    ) {
      this.Strength = obj.Strength ? obj.Strength : null;
      this.StrengthOther = obj.StrengthOther ? obj.StrengthOther : null;
      this.Attribute = obj.Attribute;
      this.LinkGuids = obj.LinkGuids;
      this.ModelNo = obj.ModelNo;
    }

    this.LevelB = obj.LevelB;
    this.Height = Number(obj.Height);
    this.ModelType = obj.ModelType;
  }

  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.No_ = obj.No_;
    this.m_sectParamData = obj.m_sectParamData;
    if (
      this.classTypeName !== "rlWallHole" &&
      this.classTypeName !== "SlabHole"
    ) {
      this.Strength = obj.Strength ? obj.Strength : null;
      this.StrengthOther = obj.StrengthOther ? obj.StrengthOther : null;
      this.Attribute = obj.Attribute;
      this.LinkGuids = obj.LinkGuids;
      this.ModelNo = obj.ModelNo;
    }

    this.LevelB = obj.LevelB;
    this.Height = Number(obj.Height);
    this.ModelType = obj.ModelType;
  }

  // handleLayerChange = (mutation, state) => {
  //   // 处理store数据变化的逻辑
  // }

  // // 二维
  // create2dModel(points) {
  //   // 将顶点坐标分组
  //   const groupedVertices = [];
  //   for (let i = 0; i < points.length; i += 3) {
  //     groupedVertices.push(new THREE.Vector3(points[i], points[i + 1], 0));
  //   }
  //   // 创建几何体
  //   const geometry = new THREE.BufferGeometry();
  //   geometry.setFromPoints(groupedVertices);

  //   const material = new THREE.LineBasicMaterial({
  //     color: 0x00acac,
  //   });

  //   const tCubeObj = new THREE.LineLoop(geometry, material);

  //   return tCubeObj;
  // }
  create2dModel(points, pWorldDraw) {
    // 将顶点坐标分组
    const groupedVertices = [];
    for (let i = 0; i < points.length; i += 3) {
      groupedVertices.push(new THREE.Vector3(points[i], points[i + 1], 0));
    }

    // 绘制连续的直线
    pWorldDraw.drawLines(groupedVertices);

    // 绘制从最后一个点到第一个点的线条,闭合
    if (groupedVertices.length > 1) {
      const lastPoint = groupedVertices[groupedVertices.length - 1];
      const firstPoint = groupedVertices[0];
      pWorldDraw.drawLine(lastPoint, firstPoint);
    }
  }

  // 三维
  create3dModel(point, indexData, JD, SX, transparent = false) {
    const vertices = new Float32Array(point);
    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute("position", new THREE.BufferAttribute(vertices, 3));
    // 不同程度缩小 解决Z-fighting冲突
    geometry.scale(0.99 - JD, 0.99 - JD, 0.99 - JD);
    geometry.setIndex(indexData);
    // 计算法线
    geometry.computeVertexNormals();

    const material = new THREE.MeshBasicMaterial({
      color: transparent ? new THREE.Color("#000") : this.Color,
      // transparent: transparent, // 设置为透明
      // opacity: transparent ? 0.1 : 0.8, // 设置透明度，取值范围为 0（完全透明）到 1（完全不透明）
      opacity: 1,
      // depthWrite: transparent,
      // blending: !transparent ? THREE.AdditiveBlending : THREE.NormalBlending,
      blending: true,
    });

    const tCubeObj = new THREE.Mesh(geometry, material);
    tCubeObj.position.y = JD ? JD : 0.0003;

    tCubeObj.renderOrder = SX; // 设置渲染顺序

    const edges = new THREE.EdgesGeometry(geometry);
    const edgeMaterial = new THREE.LineBasicMaterial({
      color: new THREE.Color("#666"),
    });
    const edgeObject = new THREE.LineSegments(edges, edgeMaterial);
    tCubeObj.add(edgeObject);

    return tCubeObj;
  }

  // 创建字体
  createText() {
    let points = this.index2dData;
    let sumX = 0;
    let sumY = 0;
    let maxX = -Infinity;
    let minX = Infinity;

    // 计算中心点
    for (let i = 0; i < points.length; i += 3) {
      const x = points[i];
      const y = points[i + 1];
      sumX += x;
      sumY += y;
      maxX = Math.max(maxX, x);
      minX = Math.min(minX, x);
    }

    // 计算中心点的xy坐标
    const centerX = sumX / (points.length / 3);
    const centerY = sumY / (points.length / 3);
    const centerPoint = new THREE.Vector3(centerX, centerY, 0);

    // if (!this.m_gridData) return;
    // const point1 = this.m_gridData.m_stJoint.m_pt;
    // const point2 = this.m_gridData.m_edJoint.m_pt;

    // const dx = point2[0] - point1[0];
    // const dy = point2[1] - point1[1];

    // let angle = Math.atan2(dy, dx);

    // // 将角度转换为从X轴开始逆时针增加
    // angle = Math.PI * 2 - angle;

    // // 如果角度是负数，那么添加 Math.PI*2
    // if (angle < 0) {
    //   angle += Math.PI * 2;
    // }

    //
    this.m_TextObj = new rlText();
    this.m_TextObj.position = centerPoint;
    this.m_TextObj.Text = this.m_sectGroupName;
    this.m_TextObj.fontSize = this.fontSize;
    this.m_TextObj.visible = this.visible;
    addEntityToDrawing(this.m_TextObj, true);
  }

  myClone() {
    let newObj = this.clone();
    newObj.SectData = this.SectData;
    newObj.m_sectParamData = this.m_sectParamData;
    newObj.index3dData = this.index3dData;
    newObj.index2dData = this.index2dData;
    newObj.points = this.points;
    newObj.m_stdFlrGuid = this.m_stdFlrGuid;
    newObj.ModelNo = this.ModelNo;
    newObj.Strength = this.Strength;
    newObj.StrengthOther = this.StrengthOther;
    newObj.LevelB = this.LevelB;
    newObj.Height = this.Height;
    return newObj;
  }
  // 偏移
  transformBy(_mat) {
    // 定义平移的偏移量
    const offsetX = _mat.x;
    const offsetY = _mat.y;
    const offsetZ = _mat.z;

    // 对每个坐标进行平移操作
    for (let i = 0; i < this.index2dData.length; i += 3) {
      this.index2dData[i] += offsetX; // 平移 x 坐标
      this.index2dData[i + 1] += offsetY; // 平移 y 坐标
      this.index2dData[i + 2] += offsetZ; // 平移 z 坐标
    }
    // 对每个坐标进行平移操作
    for (let i = 0; i < this.points.length; i += 3) {
      this.points[i] += offsetX; // 平移 x 坐标
      this.points[i + 1] += offsetY; // 平移 y 坐标
      this.points[i + 2] += offsetZ; // 平移 z 坐标
    }

    this.setNeedUpdateDisplay(true);
  }

  //数据修改更新
  async updateThisObj(obj) {
    this.initData(obj);
    this.setNeedUpdateDisplay(true);
    await resetRlModules(
      this.classTypeName,
      store.state.globalData.rl_stdFlr_id,
      this.Guid,
      this.getDataBase()
    );
  }
  erase() {
    this.m_TextObj?.erase();
    super.erase();
  }
  // 返回图形源数据
  getDataBase() {
    let data = super.getDataBase();
    data.No_ = this.No_;
    if (this.classTypeName !== "rlWallHole") {
      data["Strength"] = this.Strength;
      data["StrengthOther"] = this.StrengthOther;
      data["Attribute"] = this.Attribute;
      data["ModelNo"] = this.ModelNo;
    }

    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();

    data["m_sectParamData"] = this.m_sectParamData;
    data["LevelB"] = this.LevelB;
    data["Height"] = this.Height;
    data["Strength"] = this.Strength;
    data["StrengthOther"] = this.StrengthOther;
    data["Attribute"] = this.Attribute;

    // if (this.m_TextObj) data["m_TextObj"] = this.m_TextObj.objectId();
    data["fontSize"] = this.fontSize;
    data["SectData"] = this.SectData;
    data["ModelType"] = this.ModelType;
    return data;
  }
}

export default rlModel;
